// extracted by mini-css-extract-plugin
module.exports = {"w16o2qti":"w16o2qti","f11nk3t":"f11nk3t"};